import { useMemo, useCallback } from 'react'
import styled from 'styled-components'
import AISparkleIcon from 'components/Search/SearchForm/AISparkleIcon'
import { rem } from 'polished'
import BodyText from '../../../../LuxKit/Typography/BodyText'
import clsx from 'clsx'
import { escapeRegex } from 'lib/string/regexUtils'
import { mediaQueryUp } from '../../utils/breakpoint'
import noop from 'lib/function/noop'

interface Props {
  searchItem: App.SearchItemV3
  boldText?: string // substring to make bold
  isHighlighted?: boolean
  onClick?: (searchItem: App.SearchItemV3) => void
}

const StyledListItem = styled.button`
  display: flex;
  align-items: center;
  gap: ${rem(8)};
  border-radius: ${props => props.theme.borderRadius.L};
  cursor: pointer;

  padding: ${rem(8)} ${rem(16)} ${rem(8)} 0;
  ${mediaQueryUp.tablet} {
    padding: ${rem(8)} ${rem(16)} ${rem(8)} ${rem(12)};
  }

  &:hover {
    ${mediaQueryUp.tablet} {
      background: ${props => props.theme.palette.neutral.surface.lightBackground};
   }
  }

  &.is-highlighted {
    ${mediaQueryUp.tablet} {
      background: ${props => props.theme.palette.neutral.surface.lightBackground};
   }
  }
`

function SearchTextListItem({ searchItem, boldText = '', isHighlighted = false, onClick = noop }: Props) {
  const text = searchItem.display.mainText

  const content = useMemo(() => {
    if (!boldText) return text

    const search = new RegExp(`(${escapeRegex(boldText)})`, 'ig')
    const bits = text.split(search)

    return (
      <>
        {bits.map((textBit, index) =>
          textBit.toLowerCase() === boldText.toLowerCase()
            ? <strong key={index}>{textBit}</strong>
            : textBit,
        )}
      </>
    )
  }, [text, boldText])

  const handleClick = useCallback(() => {
    onClick(searchItem)
  }, [onClick, searchItem])

  return (
    <StyledListItem
      className={clsx({ 'is-highlighted': isHighlighted })}
      onClick={handleClick}
      type="button"
    >
      <AISparkleIcon size="S" />
      <BodyText variant="medium">{content}</BodyText>
    </StyledListItem>
  )
}

export default SearchTextListItem
